import { StudentDayStats } from 'common/components/timeback';
import {
  getCurrentDayData,
  getTodaysDayName,
} from 'common/components/timeback/StudentProgress/utils';
import { getStudentWeeklyAchievementsTotal } from 'common/components/timeback/StudentProgress/WeeklyProgressGraph/weeklyProgressGraphUtils';

interface SubjectProgressSummaryProps {
  target: number | undefined;
  data: Record<string, StudentDayStats> | undefined;
  personalGoal: number | null | undefined;
  isUserLearnAndEarn: boolean;
}

export const useStudentProgressSummary = ({
  target,
  data,
  personalGoal,
  isUserLearnAndEarn,
}: SubjectProgressSummaryProps) => {
  const dayName = getTodaysDayName();
  const todaysData = getCurrentDayData(dayName, data);
  let todaysGoal = todaysData?.target;
  // When no work done for today, use the target which is the app min target for that subject
  if (!todaysGoal && target) {
    todaysGoal = target;
  }
  const dailyGoal = isUserLearnAndEarn ? 1 : todaysGoal ?? 2;
  const dailyCompletedLessons = todaysData?.actual ?? 0;

  const { actual: weeklyCompletedLessons, target: weeklyGoalTarget } =
    getStudentWeeklyAchievementsTotal(data, dailyGoal);

  return {
    dailyCompletedLessons,
    weeklyCompletedLessons,
    dailyGoal,
    weeklyGoal: weeklyGoalTarget,
    personalDailyGoal: personalGoal,
    personalWeeklyGoal: personalGoal ? personalGoal * 5 : null,
  };
};
